import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class EndpointsService {
    public BASE_URL: string = environment.BASE_URL;
    public APP_URL: string = environment.APP_URL;
    public API_URL: string = environment.API_URL;

    public ACCOUNT_LOGIN: string = `${this.API_URL}/token`;
    public GET_CHART_DETAILS_BY_PROVIDERS_URL: string = `${this.API_URL}/v1/getChartDetailsByProvider`;
    public GET_CHART_DETAILS_BY_PROVIDERS_FOR_TODAY_URL: string = `${this.API_URL}/v1/getChartDetailsByProviderForToday`;
    public GET_CHART_DETAILS: string = `${this.API_URL}/v1/getChartDetails`;
    public GET_CHART_DETAILS_FOR_TODAY_URL: string = `${this.API_URL}/v1/getChartDetailsForToday`;
    public GET_FILTERS_URL: string = `${this.API_URL}/v1/getFilters`;
    public GET_CHART_CAMPAIGNS_URL = `${this.API_URL}/v1/getCampaignStatistics`;
    public GET_UNIQUE_REQUESTS_URL = `${this.API_URL}/v1/getUniqueRequests`;
    public GET_USERS_URL = `${this.API_URL}/v1/getUsers`;
    public CREATE_USER_URL = `${this.API_URL}/v1/createUser`;
    public DELETE_USER_URL = `${this.API_URL}/v1/deleteUser`;
    public UPDATE_USER_URL = `${this.API_URL}/v1/updateUser`;
    public GET_CLAIMS_URL = `${this.API_URL}/v1/getClaims`;
    public GET_AVAILABLE_PUBLISHERIDS_URL = `${this.API_URL}/v1/getAvailablePublisherIds`;
    public UPDATE_PUBLISHERIDS_URL = `${this.API_URL}/v1/updatePublishers`;
    public GET_FILTERED_CAMPAIGNS_URL = `${this.API_URL}/v1/getFilteredCampaigns`;
    public DELETE_CAMPAIGN_URL = `${this.API_URL}/v1/deleteCampaign`;
    public CREATE_CAMPAIGN_URL = `${this.API_URL}/v1/createCampaign`;
    public GET_CAMPAIGN_URL = `${this.API_URL}/v1/getCampaign`;
    public UPDATE_CAMPAIGN_URL = `${this.API_URL}/v1/updateCampaign`;
    public GET_CAMPAIGN_EXTRA_DETAILS_URL = `${this.API_URL}/v1/getCampaignExtraDetails`;
    public GET_BRANDS_URL = `${this.API_URL}/v1/getBrands`;
    public GET_BRAND_LOGOS_URL = `${this.API_URL}/v1/getBrandLogos`;
    public GET_BRAND_LOGOS_LIST_URL = `${this.API_URL}/v1/getBrandLogosList`;
    public CREATE_BRAND_LOGO_URL = `${this.API_URL}/v1/createBrandLogo`;
    public CREATE_BRAND_AND_LOGO_URL = `${this.API_URL}/v1/createBrandAndLogo`;
    public GET_BRANDS_STATISTICS_LIST_URL = `${this.API_URL}/v1/getBrandsStatistics`;
    public REMOVE_BRAND_TO_AD_ASSOCIATION = `${this.API_URL}/v1/removeBrandToAdAssociation`;
    public GENERATE_AD_TRAILER = `${this.API_URL}/v1/generateAdTrailer`;
    public GET_AD_TRAILER = `${this.API_URL}/v1/getAdTrailer`;
    public GET_BRAND_BY_LOGO_URL = `${this.API_URL}/v1/getBrandByLogo`;
    public DELETE_BRAND_LOGO = `${this.API_URL}/v1/deleteBrandLogo`;
    public CREATE_PUBLISHER_CAMPAIGN_ALLOCATION_URL = `${this.API_URL}/v1/createPublisherAllocation`;
    public UPDATE_PUBLISHER_CAMPAIGN_ALLOCATION_URL = `${this.API_URL}/v1/updatePublisherAllocation`;
    public DELETE_PUBLISHER_CAMPAIGN_ALLOCATION_URL = `${this.API_URL}/v1/deletePublisherAllocation`;
    public CREATE_PPA_URL = `${this.API_URL}/v1/createPpa`;
    public UPDATE_PPA_URL = `${this.API_URL}/v1/updatePpa`;
    public DELETE_PPA_URL = `${this.API_URL}/v1/deletePpa`;
    public GET_PPA_FIEDLS_URL = `${this.API_URL}/v1/getPpaFields`;
    public GET_COUNTRIES_BY_PUBLISHER_URL = `${this.API_URL}/v1/getCountriesByPublisher`;
    public GET_PROVIDER_BY_NAME_URL = `${this.API_URL}/v1/getProviderByName`;
    public GET_CAROUSEL_ORDER_URL = `${this.API_URL}/v1/getCarouselOrder`;
    public UPDATE_CAROUSEL_ORDER_URL = `${this.API_URL}/v1/updateCarouselOrder`;
    public GET_PAYMENT_CHART_DATA_URL = `${this.API_URL}/v1/getChartData`;
    public GET_PAYMENT_LIST_URL = `${this.API_URL}/v1/getPaymentList`;
    public UPDATE_PAYMENT_URL = `${this.API_URL}/v1/updatePayment`;
    public CREATE_PAYMENT_URL = `${this.API_URL}/v1/createPayment`;
    public GET_ALLOWED_PUBLISHER_IDS_FROM_CAROUSEL_ORDER = `${this.API_URL}/v1/getAllowedPublisherIdsFromCarouselOrder`;
    public GET_ALLOWED_PUBLISHER_IDS_BY_PROVIDER_AND_COUNTRY = `${this.API_URL}/v1/getAllowedPublisherIdsForProviderAndCountry`;
    public SEND_FORGOT_PASSWORD_URL = `${this.API_URL}/v1/forgotPassword`;
    public SEND_RESET_PASSWORD_URL = `${this.API_URL}/v1/resetPassword`;
    public GET_PUBLISHERS_DETAILS = `${this.API_URL}/v1/getPublishers`;
    public CREATE_PUBLISHER_URL = `${this.API_URL}/v1/createPublisher`;
    public GET_REVENUE_REPORTS = `${this.API_URL}/v1/getRevenueReports`;
    public GET_FILL_REPORTS = `${this.API_URL}/v1/getFillReports`;
    public GENERATE_REPORT = `${this.API_URL}/v1/generateReport`;
    public GET_LATEST_SAVED_REPORTS = `${this.API_URL}/v1/getLatestSavedReports`;
    public GET_UNIDENTIFIED_ADS = `${this.API_URL}/v1/getUnidentifiedAds`;
    public SET_IDENTIFIED_AD = `${this.API_URL}/v1/setIdentifiedAd`;
    public GET_VERSION_NUMBER = `${this.API_URL}/v1/getVersionNumber`;
    public GET_CREATIVES_URL = `${this.API_URL}/v1/getCreatives`;
    public CREATE_CREATIVE_URL = `${this.API_URL}/v1/createCreative`;
    public GET_PROVIDERS_FOR_PUBLISHER_URL = `${this.API_URL}/v1/getProvidersForPublisher`;
    public GET_COUNTRIES_FOR_PUBLISHER_AND_PROVIDER_URL = `${this.API_URL}/v1/getCountriesForPublisherAndProvider`;
    public GET_ASSETS_URL = `${this.API_URL}/v1/getAssets`;
    public CREATE_ASSET_URL = `${this.API_URL}/v1/createAsset`;
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/app/core/services/endpoints.service.ts